var map = {
	"./3d-glasses-1.png": 512,
	"./3d-glasses-2.png": 513,
	"./3d-glasses-3.png": 514,
	"./3d-glasses-4.png": 515,
	"./action-cam-1.png": 516,
	"./action-cam-2.png": 517,
	"./action-cam-3.png": 518,
	"./action-cam-4.png": 519,
	"./ecommerce-product-img-1.png": 520,
	"./ecommerce-product-img-2.png": 521,
	"./portable-speaker-1.png": 522,
	"./portable-speaker-2.png": 523,
	"./portable-speaker-3.png": 524,
	"./speaker-1.png": 525,
	"./speaker-2.png": 526,
	"./speaker-3.png": 527,
	"./watch-1.png": 528,
	"./watch-2.png": 529,
	"./watch-3.png": 530,
	"./watch-4.png": 531,
	"./watch-card.png": 532,
	"./white-cam-1.png": 533,
	"./white-cam-2.png": 534,
	"./white-cam-3.png": 535,
	"./white-cam-4.png": 536,
	"./white-cam-card.png": 537,
	"./wifi-1.png": 538,
	"./wifi-2.png": 539,
	"./wifi-3.png": 540,
	"./wireless-bluetooth-1.png": 541,
	"./wireless-bluetooth-2.png": 542,
	"./wireless-bluetooth-3.png": 543,
	"./wireless-bluetooth-4.png": 544,
	"./x-box-image-detail-1.png": 545,
	"./x-box-image-detail-2.png": 546,
	"./x-box-image-detail-3.png": 547,
	"./x-box-image-detail-4.png": 548,
	"./xbox-1.png": 549,
	"./xbox-2.png": 550,
	"./xbox-3.png": 551,
	"./xbox-4.png": 552,
	"./xbox-black.png": 553,
	"./xbox-blue.png": 554,
	"./xbox-red.png": 555,
	"./xbox-white.png": 556
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 511;